
import { computed } from "@vue/composition-api";
import Vue from "vue";
import { diff, getMinutes } from "./@types";
export default Vue.extend({
  props: {
    from: String,
    to: String,
  },
  computed: {
    range(): { offset: number; duration: number } {
      const offset = getMinutes(this.from);
      const d = diff(this.from, this.to);
      return { offset: (offset / (24 * 60)) * 100, duration: (getMinutes(d) / (24 * 60)) * 100 };
    },
    day1(): { offset: number; width: number } {
      return { offset: this.range.offset, width: Math.max(1, Math.min(this.range.duration, 100 - this.range.offset)) };
    },
    day2(): { offset: number; width: number } | null {
      if (this.range.duration + this.range.offset > 100) {
        return { offset: 0, width: Math.max(1, this.range.duration - (100 - this.range.offset)) };
      }
      return null;
    },
  },
});
